<template>
  <div class="animate__animated animate__fadeIn">
    <h4 class="font-weight-bold">Condições Financeiras</h4>
    <div class="row">
      <div class="col-md-12">
        <b-tabs content-class="mt-3">
          <b-tab title="Renda" active>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>
                    Renda total da família <br /><strong>{{
                      financeiro.renda_total_familiar | moedaRS()
                    }}</strong>
                  </td>
                  <td>
                    Valor da renda média (per capita) da família:
                    <br /><strong>{{ renda_percapita | moedaRS() }}</strong>
                    <label
                      v-if="
                        financeiro.per_capita_familiar <=
                        this.$store.state.settings.familia_extrema_pobreza
                      "
                      class="badge badge-danger"
                    >
                      Pobreza
                    </label>
                    <label
                      v-if="
                        renda_percapita >
                          this.$store.state.settings.familia_extrema_pobreza &&
                        renda_percapita <=
                          this.$store.state.settings.familia_pobreza
                      "
                      class="badge badge-danger"
                      >Pobreza</label
                    >
                    <label
                      v-if="
                        renda_percapita >=
                        this.$store.state.settings.familia_perfil_cadunico
                      "
                      class="badge badge-primary"
                    >
                      Perfil Cadunico
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    Renda total da família (incluindo programas sociais e
                    benefícios): <br />
                    <strong>
                      {{
                        (financeiro.renda_total_familiar +
                          beneficioValor +
                          programasValor)
                          | moedaRS()
                      }}
                    </strong>
                  </td>
                  <td>
                    Renda familiar per capita (incluindo programas sociais e
                    benefícios)<br />
                    <strong>
                      {{
                        (renda_percapita + beneficioValor + programasValor)
                          | moedaRS()
                      }}</strong
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab title="Ocupação">
            <div class="col-md-12 mt-3 px-0">
              <h5 class="font-weight-bold">
                Ocupação e qualificação dos familiares
              </h5>
              <div v-for="usuario in item.familiares" :key="usuario.id">
                <div class="p-0 col-12 mb-3" v-if="usuario.remuneracao[0]">
                  <table class="table table-bordered">
                    <tbody>
                      <tr class="col-12">
                        <td colspan="2">
                          <router-link
                            :to="'/dashboard/usuario/edit/' + usuario.id"
                          >
                            <strong>
                              {{ usuario.nome_completo }}
                            </strong>
                          </router-link>
                          <br />
                          Idade:
                          {{ usuario.idade }}
                          ano(s)<br />
                        </td>
                      </tr>
                      <tr>
                        <th>Possui Carteira de Trabalho?</th>
                        <td>
                          {{
                            usuario.remuneracao
                              ? usuario.remuneracao[0].profissao_principal ==
                                "4"
                                ? "Sim"
                                : "Não"
                              : ""
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Condição de Ocupação</th>
                        <td>
                          {{
                            findJob(usuario.remuneracao[0].profissao_principal)
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Possui qualificação profissional?</th>
                        <td>
                          {{
                            usuario.remuneracao[0].qualificacao_profissional ==
                            1
                              ? "Sim " +
                                changeNome(
                                  usuario.remuneracao[0].profissao_nome
                                )
                              : "Não"
                          }}
                        </td>
                      </tr>
                      <tr v-if="usuario.remuneracao[0].valor_remuneracao > 0">
                        <th>Valor da Remuneração</th>
                        <td>
                          {{
                            checkValue(usuario.remuneracao[0].valor_remuneracao)
                              | moedaRS()
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- </tbody>
							</table> -->
            </div>
          </b-tab>
          <b-tab title="Despesas">
            <div v-if="!show_historico">
              <div class="row mt-3">
                <div class="col-md-7">
                  <h5 class="font-weight-bold">Despesas mensais da familia:</h5>
                </div>
                <div class="col-md-5 text-right">
                  <p class="font-weight-light font-italic">
                    <a
                      href="#"
                      class="router-link-exact-active active"
                      @click="show_historico = true"
                    >
                      <i class="fas fa-history"></i>
                      Histórico de Despesas
                    </a>
                  </p>
                </div>
              </div>
              <div class="row">
                <form-input
                  v-model="financeiro.val_desp_energia"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Energia elétrica"
                />
                <form-input
                  v-model="financeiro.val_desp_agua"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Água e esgoto"
                />
                <form-input
                  v-model="financeiro.val_desp_gas"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Gás, carvão e lenha"
                />
                <form-input
                  v-model="financeiro.val_desp_alimentacao"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Alimentação, higiene e limpeza"
                />

                <form-input
                  v-model="financeiro.val_desp_transporte"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Transporte"
                />

                <form-input
                  v-model="financeiro.val_desp_aluguel"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Aluguel"
                />

                <form-input
                  v-model="financeiro.val_desp_medicamentos"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Medicamentos de uso regular"
                />

                <form-input
                  v-model="financeiro.val_desp_outros"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Outras despesas"
                />

                <form-input
                  v-model="sumRendas"
                  grid="4"
                  inputGroup="true"
                  btnText="R$"
                  :type="'number'"
                  label="Total de despesas"
                  :readonly="true"
                />
              </div>
              <div class="row mt-2">
                <div class="col-md-9">
                  <div class="float-left mt-2 mr-3">
                    <toggle-button
                      :sync="true"
                      color="#5685D8"
                      v-model="cadastrarFinanceiro"
                      class="float-left mr-3"
                    />
                    Cadastrar novas despesas?
                  </div>
                </div>

                <div class="col-md-3 text-right">
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    @click="submit"
                    type="submit"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <Historico
                @voltar="show_historico = false"
                :familia-id="$route.params.id"
              />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Historico from "../historico/Financeiro";
export default {
  components: { Historico },
  props: ["item"],
  data() {
    return {
      renda_percapita: 0,
      per_capita_familiar: 0,
      renda_total_familiar: 0,
      cadastrarFinanceiro: 0,
      show_historico: false,
      beneficioValor: 0,
      beneficios: [],
      programasValor: 0,
      programas: [],
      financeiro: {
        renda_total_familiar: 0,
        per_capita_familiar: 0,
        val_desp_energia: 0,
        val_desp_agua: 0,
        val_desp_gas: 0,
        val_desp_alimentacao: 0,
        val_desp_transporte: 0,
        val_desp_aluguel: 0,
        val_desp_medicamentos: 0,
        val_desp_outros: 0,
        total_desp: 0,
        observacoes_financeiro: null,
      },
    };
  },
  mounted() {
    if (this.item.financeiro != null) {
      this.financeiro = this.item.financeiro;
    }
    if (this.item.beneficiosEventuais != null) {
      this.beneficios = this.item.beneficiosEventuais;
    }
    if (this.item.programas_sociais != null) {
      this.programas = this.item.programas_sociais;
    }
    this.per_capita_familiar = this.item.renda_calculo
      ? parseInt(this.checkValue(this.item.renda_calculo)) /
        this.item.familiares.length
      : parseInt(this.checkValue(this.financeiro.per_capita_familiar)) / 100;

    this.renda_total_familiar = this.item.renda_calculo
      ? this.checkValue(this.item.renda_calculo)
      : this.checkValue(this.financeiro.renda_total_familiar);

    console.clear();
    console.log("Renda percapita", this.financeiro.per_capita_familiar);
    this.renda_percapita = parseInt(
      this.checkValue(this.financeiro.per_capita_familiar)
    );
  },
  updated() {},
  computed: {
    sumRendas() {
      var sumBeneficio = 0;
      var sumProgramas = 0;

      this.beneficios.forEach((elem) => {
        sumBeneficio += elem.valor;
      });
      this.programas.forEach((elem) => {
        sumProgramas += elem.valor;
      });

      this.beneficioValor = sumBeneficio;
      this.programasValor = sumProgramas;

      var valores = [
        this.checkValue(this.financeiro.val_desp_energia),
        this.checkValue(this.financeiro.val_desp_agua),
        this.checkValue(this.financeiro.val_desp_gas),
        this.checkValue(this.financeiro.val_desp_alimentacao),
        this.checkValue(this.financeiro.val_desp_transporte),
        this.checkValue(this.financeiro.val_desp_aluguel),
        this.checkValue(this.financeiro.val_desp_medicamentos),
        this.checkValue(this.financeiro.val_desp_outros),
      ];

      return (this.financeiro.total_desp = valores.reduce((a, b) => a + b));
    },
  },
  methods: {
    findJob(profissao_principal) {
      const job = this.$root.arrays.profissao_principal.find(
        (element) => element.id == profissao_principal
      );
      return job ? job.value : "";
    },
    changeNome(nome) {
      return nome != undefined || nome != null ? "," + nome : "";
    },
    checkValue(a) {
      return a == null ? 0 : parseInt(a);
    },
    truncate(text, length) {
      if (text.length > length) {
        return text.substring(0, length);
      } else {
        return text;
      }
    },
    submit() {
      this.item.financeiro = this.financeiro;
      this.item.cadastrarFinanceiro = this.cadastrarFinanceiro;
      this.$emit("submit");
    },
  },
};
</script>
